import React, {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import JobCostPOFilters from "./jobCostPOFilters";
import JobCostPOBody from "./jobCostPOBody";
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Job Cost PO ViewPoint Report
 * @returns {JSX.Element}
 * @constructor
 */
const JobCostPO = () => {
    const [tableData, setTableData] = useState([]);
    const [reportFilters, setReportFilters] = useState({
        isLoading: false,
        isSubmitted: false,
    });

    const jobCostPOFilterProps = {
        setReportFilters,
        setTableData,
    }

    const jobCostPOBodyProps = {
        tableData,
        reportFilters
    }

    return (
        <>
            <Breadcrumb title="Job Cost PO" parent="Invoicing"/>
            <JobCostPOFilters {...jobCostPOFilterProps}/>
            <JobCostPOBody {...jobCostPOBodyProps}/>
            <LoadingIndicator isLoading={reportFilters.isLoading}/>
        </>
    );
}

export default JobCostPO;
